import { Component, Injector } from "@angular/core";
import { ExtensionRegistry, GeoappbaseClientInitializer, PrivacyBannerComponent } from "@geolib/geoappbase-client";
import { TranslateService } from "@ngx-translate/core";
import { UIView } from "@uirouter/angular";
import { loadMessages, locale } from "devextreme/localization";
import deMessages from "devextreme/localization/messages/de.json";
import translationDe from "../data/local-de_DE.json";
import AppInitializer from "./AppInitializer";
import { AppConstants } from "./common/app-constants";
import { registerExtensions } from "./extensions";
import { AppColorThemeSwitcher } from "./theme/AppColorThemeSwitcher";

@Component({
    selector: "app-component",
    templateUrl: "./appComponent.html",
    imports: [UIView, PrivacyBannerComponent],
})
export default class AppComponent {

    public readonly pathOfImpressum = AppConstants.PATH_OF_IMPRESSUM;

    public constructor(
        private readonly translateService: TranslateService,
        private readonly injector: Injector,
        private readonly extensionRegistry: ExtensionRegistry,
    ) {
        this.setTranslation();
        registerExtensions(this.extensionRegistry, this.injector);
        this.injector.get(AppColorThemeSwitcher);
        this.injector.get(AppInitializer);
        this.injector.get(GeoappbaseClientInitializer);
    }

    private setTranslation(): void {
        this.translateService.setTranslation("de", translationDe);
        this.translateService.setDefaultLang("de");
        this.translateService.use("de");

        loadMessages(deMessages);
        locale("de-CH");
    }

}
